import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get('admin/master/rtw-product/page', params)
const getDetail = (id) => get(`admin/master/rtw-product/${id}`)
const putData = params => put(`admin/master/rtw-product/${params.id}`, params)
const postData = params => post(`admin/master/rtw-product`, params)


const RtwProductAPI = {
  getListPage,
  getDetail,
  postData,
  putData,
}

export default RtwProductAPI